import {observable, action} from 'mobx';

/**
 * Home Store
 */
export default class HomeStore {
  @observable check = false;

  /**
   * change check state
   * @param {boolean} state
   */
  @action clearState() {
    this.check = false;
  }

  /**
   * change check state
   * @param {boolean} state
   */
  @action changeCheckState(state) {
    this.check = state;
  }
}



// WEBPACK FOOTER //
// ./src/js/stores/home/index.js